import { ArrowSmRightIcon } from '@heroicons/react/outline';
import { dropDownCardLG } from 'assets';
import Cookies from 'js-cookie';
import moment from 'moment';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import { formateErrorObject } from '@/components/shared/formateErrorObject';
import { notify } from '@/components/shared/notify';

import { getRewardRulesByName } from '@/services/reward';

interface Props {
  setShowDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}
const ReferEarn: React.FC<Props> = ({ setShowDropDown, onClose }) => {
  const [coins, setCoins] = useState<any>(600);
  const router = useRouter();
  const REWARD_COOKIE_KEY = 'welcome_bonus';

  const handleRewardCoin = async (setCoins: (coins: any) => void) => {
    try {
      const cached = Cookies.get(REWARD_COOKIE_KEY);

      if (cached) {
        const parsed = JSON.parse(cached);
        const now = moment();
        const expiry = moment(parsed.expiry);

        if (now.isBefore(expiry)) {
          setCoins(parsed.data);
          return;
        }
      }

      const data = await getRewardRulesByName(REWARD_COOKIE_KEY);
      setCoins(data.data);

      const expiryTime = moment().add(6, 'hours').toISOString();

      Cookies.set(
        REWARD_COOKIE_KEY,
        JSON.stringify({
          data: data.data,
          expiry: expiryTime,
        }),
        { expires: 1 },
      );
    } catch (error: any) {
      const message =
        formateErrorObject(error) || 'An error occurred while fetching data.';
      notify(message, 'error');
    }
  };

  useEffect(() => {
    handleRewardCoin(setCoins);
  }, []);
  return (
    <div className='px-5'>
      <div
        onClick={() => {
          onClose();
          router.push('/refer-earn');
          setShowDropDown(false);
        }}
        className='relative flex gap-x-2 w-full h-[96px] border rounded-lg border-white/5 overflow-hidden'
      >
        <Image
          src={dropDownCardLG}
          alt='Facebook'
          className='absolute top-0 right-0 h-[94px] min-w-[348px] w-[348px] max-w-[348px]'
        />{' '}
        <div className='absolute top-0 left-0 w-full h-full'>
          <div className='flex flex-col h-full justify-between py-2.5 px-4'>
            <div className='flex flex-col z-40'>
              <span className='text-base/6 font-semibold  text-white'>
                Get A Free Book
              </span>
              <span className='text-[10px] leading-[18px] font-normal text-white/80 '>
                When your friend joins, both get{' '}
                <span className='font-semibold text-white'>{coins} Z Coin</span>
              </span>
            </div>

            <div className='text-[10px] leading-[18px] font-normal text-white/80 flex items-center gap-1'>
              <p>1 Z coin = 1 Rupees</p>
              <div className='w-4 h-4 rounded-full flex items-center justify-center bg-white/10'>
                <ArrowSmRightIcon className='w-[11px] h-[11px]' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferEarn;
